import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logoLight from "../img-nav-light.webp";
import logoDark from "../img-nav-dark.webp";

const Navbar = ({ settings, lang, setLang, theme, setTheme }) => {
    const location = useLocation();
    const [isNavCollapsed, setIsNavCollapsed] = useState(true);
    const [scrolled, setScrolled] = useState(false);
    const [hideNav, setHideNav] = useState(false);

    const handleNavCollapse = () => {
        setIsNavCollapsed(!isNavCollapsed);
        // Toggle body overflow
        if (isNavCollapsed) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    };

    const isActive = (path) => {
        if (path === '/') return location.pathname === '/';
        return location.pathname.startsWith(path);
    };

    const getText = (en, ar) => (lang === "en" ? en : ar);

    // Scroll Effect Logic
    useEffect(() => {
        // ينفذ فقط لما يكون العرض أكبر من 991px
        if (window.innerWidth <= 991) return;

        const navbar = document.querySelector(".navbar");
        const yearEl = document.getElementById("year");

        // Scroll Handler
        const handleScroll = () => {
            if (!navbar) return;

            if (window.scrollY > 50) {
                navbar.classList.add("shadow-sm");
                navbar.classList.add("navbar-scrolled");
            } else {
                navbar.classList.remove("shadow-sm");
                navbar.classList.remove("navbar-scrolled");
            }
        };

        // حدّث السنة مرة واحدة
        if (yearEl) yearEl.innerText = new Date().getFullYear();

        // أربط الحدث
        window.addEventListener("scroll", handleScroll);

        // Cleanup
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    useEffect(() => {
        const mq = window.matchMedia("(max-width: 992px)");
        let lastScroll = window.scrollY;

        const navbar = document.querySelector(".nav-big");
        const navMobile = document.querySelector(".nav-mobile");
        const menu = document.querySelector("#navbarNav");

        if (!navbar || !navMobile) return;

        const onScroll = () => {
            const y = window.scrollY;
            const isMenuOpen =
                menu &&
                (menu.classList.contains("show") ||
                    menu.classList.contains("collapsing"));

            if (y < 100 || isMenuOpen) {
                navbar.classList.remove("hide-up");
                navMobile.classList.remove("hide-down");
            } else if (y > lastScroll && y > 100) {
                navbar.classList.add("hide-up");
                navMobile.classList.add("hide-down");
            } else {
                navbar.classList.remove("hide-up");
                navMobile.classList.remove("hide-down");
            }

            lastScroll = y;
        };

        const disableLargeBehavior = () => {
            window.removeEventListener("scroll", onScroll);
            document.querySelectorAll(".navbar, .nav-mobile").forEach((el) => {
                el.classList.remove("scroll-anim", "hide-up", "hide-down");
                el.style.transform = "";
            });
        };

        const enableLargeBehavior = () => {
            document.querySelectorAll(".navbar, .nav-mobile").forEach((el) => {
                el.classList.add("scroll-anim");
                el.classList.remove("hide-up", "hide-down");
            });

            lastScroll = window.scrollY;
            window.addEventListener("scroll", onScroll);
            onScroll();
        };

        // Apply on first load
        if (mq.matches) enableLargeBehavior();
        else disableLargeBehavior();

        // Listen to screen size changes
        mq.addEventListener("change", (e) =>
            e.matches ? enableLargeBehavior() : disableLargeBehavior()
        );

        // Cleanup on unmount
        return () => {
            window.removeEventListener("scroll", onScroll);
            mq.removeEventListener("change", () => { });
        };
    }, []);


    const toggleTheme = () => {
        setTheme(theme === "light" ? "dark" : "light");
    };

    const navClasses = `navbar navbar-expand-lg navbar-custom sticky-top bg-card nav-big ${scrolled ? 'navbar-scrolled shadow-sm' : ''} ${hideNav ? 'hide-up' : ''}`;
    const mobileNavClasses = `nav-mobile d-lg-none ${hideNav ? 'hide-down' : ''}`;

    return (
        <>
            <nav className={navClasses}>
                <div className="container">
                    <Link className="py-0 navbar-brand fw-bold text-primary fs-4" to="/">
                        <img
                            src={theme === 'dark' ? logoDark : logoLight}
                            alt="InnoBridge Logo"
                            style={{ height: '50px', width: 'auto' }}
                        />
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={handleNavCollapse}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`collapse navbar-collapse ${!isNavCollapsed ? 'show' : ''}`} id="navbarNav">
                        <ul className="navbar-nav mx-auto">
                            <li className="nav-item">
                                <Link
                                    className={`nav-link nav-link-custom ${isActive('/') ? 'active' : ''}`}
                                    to="/"
                                    onClick={() => {
                                        setIsNavCollapsed(true);
                                        document.body.style.overflow = 'auto';
                                    }}
                                >
                                    {getText("Home", "الرئيسية")}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={`nav-link nav-link-custom ${isActive('/about') ? 'active' : ''}`}
                                    to="/about"
                                    onClick={() => {
                                        setIsNavCollapsed(true);
                                        document.body.style.overflow = 'auto';
                                    }}
                                >
                                    {getText("About", "من نحن")}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={`nav-link nav-link-custom ${isActive('/services') ? 'active' : ''}`}
                                    to="/services"
                                    onClick={() => {
                                        setIsNavCollapsed(true);
                                        document.body.style.overflow = 'auto';
                                    }}
                                >
                                    {getText("Services", "خدماتنا")}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={`nav-link nav-link-custom ${isActive('/projects') ? 'active' : ''}`}
                                    to="/projects"
                                    onClick={() => {
                                        setIsNavCollapsed(true);
                                        document.body.style.overflow = 'auto';
                                    }}
                                >
                                    {getText("Projects", "مشاريعنا")}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={`nav-link nav-link-custom ${isActive('/blog') ? 'active' : ''}`}
                                    to="/blog"
                                    onClick={() => {
                                        setIsNavCollapsed(true);
                                        document.body.style.overflow = 'auto';
                                    }}
                                >
                                    {getText("Blog", "المدونة")}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={`nav-link nav-link-custom ${isActive('/careers') ? 'active' : ''}`}
                                    to="/careers"
                                    onClick={() => {
                                        setIsNavCollapsed(true);
                                        document.body.style.overflow = 'auto';
                                    }}
                                >
                                    {getText("Jobs", "الوظائف")}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={`nav-link nav-link-custom ${isActive('/contact') ? 'active' : ''}`}
                                    to="/contact"
                                    onClick={() => {
                                        setIsNavCollapsed(true);
                                        document.body.style.overflow = 'auto';
                                    }}
                                >
                                    {getText("Contact", "اتصل بنا")}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className={`nav-link nav-link-custom ${isActive('/map') ? 'active' : ''}`}
                                    to="/map"
                                    onClick={() => {
                                        setIsNavCollapsed(true);
                                        document.body.style.overflow = 'auto';
                                    }}
                                >
                                    {getText("Branches", "فروعنا")}
                                </Link>
                            </li>
                        </ul>
                        <div className="d-flex align-items-center gap-3 d-lg-flex d-none">
                            <button
                                className="lang-toggle btn btn-outline-custom btn-sm d-flex align-items-center gap-2"
                                onClick={() => setLang(lang === "en" ? "ar" : "en")}
                            >
                                <span>{lang === "en" ? "Ar" : "En"}</span>
                            </button>
                            <button className="theme-toggle btn btn-outline-custom btn-sm" onClick={toggleTheme}>
                                <i className={theme === 'light' ? "ri-moon-line" : "ri-sun-line"}></i>
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Overlay for mobile menu */}
            <div
                className={`menu-overlay ${!isNavCollapsed ? 'show' : ''}`}
                onClick={handleNavCollapse}
            ></div>

            {/* Mobile Nav */}
            <section className={mobileNavClasses}>
                <div className="d-flex w-100 justify-content-evenly">
                    <Link to="/" className={`link-mob d-flex flex-column align-items-center ${isActive('/') ? 'active' : ''}`}>
                        <i className="ri-home-2-line"></i>
                        <span>{getText("Home", "الرئيسية")}</span>
                    </Link>
                    <Link to="/map" className={`link-mob d-flex flex-column align-items-center ${isActive('/map') ? 'active' : ''}`}>
                        <i className="ri-map-2-line"></i>
                        <span>{getText("Branches", "فروعنا")}</span>
                    </Link>
                    <Link to="/careers" className={`link-mob d-flex flex-column align-items-center ${isActive('/careers') ? 'active' : ''}`}>
                        <i className="ri-briefcase-line"></i>
                        <span>{getText("Jobs", "الوظائف")}</span>
                    </Link>
                    <div className="theme-toggle link-mob d-flex flex-column align-items-center" onClick={toggleTheme} style={{ cursor: 'pointer' }}>
                        <i className={theme === 'light' ? "ri-moon-line" : "ri-sun-line"}></i>
                        <span>{theme === 'light' ? getText("Dark", "الداكن") : getText("Light", "الفاتح")}</span>
                    </div>
                    <div
                        className="lang-toggle link-mob d-flex flex-column align-items-center"
                        onClick={() => setLang(lang === "en" ? "ar" : "en")}
                        style={{ cursor: 'pointer' }}
                    >
                        <i className="ri-global-line"></i>
                        <span>{getText("En", "Ar")}</span>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Navbar;
